// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"style_dropzone__2WDZg","img_preview":"style_img_preview__1VLNq"};